import { memo } from 'react';
import { AccountCardMemo } from './AccountCard';
import { IConnectedAccountsListProps } from '@/@types/socialMedia';

/**
 * List of connected social media accounts
 */
const ConnectedAccountsList = ({
  accounts,
  isLoading,
  onDisconnect,
  onReconnect,
}: IConnectedAccountsListProps) => {
  const hasAccounts = accounts.length > 0;
  const showEmptyState = !isLoading && !hasAccounts;

  return (
    <div className="space-y-4">
      {isLoading && (
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground" />
        </div>
      )}

      {showEmptyState && (
        <div className="text-center py-12 px-4">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
            <svg
              className="w-8 h-8 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-foreground mb-2">No connected accounts</h3>
          <p className="text-sm text-muted-foreground max-w-sm mx-auto">
            Connect your Facebook Page to start publishing AI-generated posts directly to social
            media.
          </p>
        </div>
      )}

      {hasAccounts && (
        <div className="space-y-3">
          {accounts.map(account => (
            <AccountCardMemo
              key={account._id}
              account={account}
              onDisconnect={onDisconnect}
              onReconnect={onReconnect}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export const ConnectedAccountsListMemo = memo(ConnectedAccountsList);
